const hasUserRole = (userRole: string | string[], userRoleToMatch: string) => {
    let hasRole = false;
  
    if (typeof userRole === "string") {
      hasRole = userRole === userRoleToMatch;
    } else if (Array.isArray(userRole)) {
      hasRole = userRole.some((role) => role === userRoleToMatch);
    }
  
    return hasRole;
  };
  
  export default hasUserRole;
  